/*!
 *   Copyright 2022  SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
@import "../../scss/vars";

:host {
  & > div {
    width: 100%;
    height: 100%;
  }

  #ws {
    color: transparent;
    font-size: 0;
  }


  .discovery-tile-error {
    background-color: var(--warp-view-error-bg-color, $w10-danger);
    color: var(--warp-view-error-color, $w10-white);
    text-align: center;
    position: absolute;
    width: calc(100% - 40px);
    padding: 20px;
    height: calc(100% - 40px);
    z-index: 9;
    display: grid;
    align-items: center;
  }

  .discovery-dashboard-main {
    height: calc(100% - 20px);
    text-align: center;
    color: var(--warp-view-font-color, $w10-charcoal);
    background: var(--warp-view-dashboard-background, $w10-transparent);
    background-size: cover;
    padding: 10px;
    width: calc(100% - 20px);

    .discovery-dashboard-wrapper {
      display: grid;
      grid-gap: var(--warp-view-dashboard-gap, 10px);
      padding-bottom: 20px;

      .discovery-dashboard-tile {
        width: 100%;
        border: var(--warp-view-tile-border, .1rem solid rgba(0, 0, 0, .075)) !important;
        box-shadow: var(--warp-view-tile-shadow, 0 0.125rem 0.25rem rgb(0 0 0 / 8%)) !important;
        border-radius: var(--warp-view-tile-border-radius, 0);
        overflow: visible;
        background: var(--warp-view-tile-background, $w10-transparent);


        &.dashboard, &.dashboard-flex, &.dashboard-scada {
          overflow-y: auto;
          overflow-x: visible;
          margin-bottom: 20px;
        }

        &.dashboard.auto-height, &.dashboard-flex.auto-height, &.dashboard-scada.auto-height {
          height: auto !important;
       //   overflow: hidden;
          overflow: visible;
          margin-bottom: 20px;
        }

        &.annotation, &.plot {
          height: 100% !important;
        }

        &.hidden {
          opacity: 0;
          visibility: hidden;
        }

        & > div {
          width: 100%;
          height: 100%;
          margin-bottom: -20px;
        }
      }
    }
  }

  .discovery-flex-main {
    height: 100%;
    text-align: center;
    color: var(--warp-view-font-color, $w10-charcoal);
    background: var(--warp-view-dashboard-background, $w10-transparent);
    background-size: cover;
    padding: 10px;
    width: calc(100% - 20px);

    .discovery-flex-wrapper {
      display: inline-flex;
      flex-direction: row;
      flex-wrap: wrap;
      min-width: 200px;
      min-height: 500px;
      justify-content: start;
      width: 100%;
    }

    .discovery-dashboard-tile {
      flex-grow: 1;
      width: 100%;
      overflow: visible;
      padding: var(--warp-view-dashboard-gap, 10px);

      &.dashboard, &.dashboard-flex, &.dashboard-scada {
        height: auto !important;
        margin-bottom: 20px;
      }

      &.dashboard.auto-height, &.dashboard-flex.auto-height, &.dashboard-scada.auto-height {
        height: auto !important;
        overflow: hidden;
        margin-bottom: 20px;
      }

      & > div {
        width: 100%;
        height: 100%;
        border-radius: var(--warp-view-tile-border-radius, 0);
        border: var(--warp-view-tile-border, .1rem solid rgba(0, 0, 0, .075)) !important;
        box-shadow: var(--warp-view-tile-shadow, 0 0.125rem 0.25rem rgb(0 0 0 / 8%)) !important;
      }

      &.hidden {
        visibility: collapse;
        height: 0 !important;
        margin: 0;
        padding: 0;
      }
    }

    @media (max-width: 800px) {
      .discovery-dashboard-tile {
        max-width: calc(50% - 25px) !important;
      }
    }

    @media (max-width: 600px) {
      .discovery-dashboard-tile {
        max-width: 100% !important;
      }
    }
  }

  .discovery-scada-main {
    padding: 10px;
    width: calc(100% - 20px);
    height: auto;
    text-align: center;
    color: var(--warp-view-font-color, $w10-charcoal);
    background: var(--warp-view-dashboard-background, $w10-transparent);
    background-size: cover;

    .discovery-scada-wrapper {
      position: relative;
      height: 100%;
      padding-bottom: 20px;

      .discovery-scada-tile {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        border: var(--warp-view-tile-border, .1rem solid rgba(0, 0, 0, .075));
        box-shadow: var(--warp-view-tile-shadow, 0 0.125rem 0.25rem rgb(0 0 0 / 8%));
        border-radius: var(--warp-view-tile-border-radius, 0);
        overflow: visible;
        background: var(--warp-view-tile-background);

        &.dashboard, &.dashboard-flex, &.dashboard-scada {
          overflow: auto;
        }

        &.dashboard.auto-height, &.dashboard-flex.auto-height, &.dashboard-scada.auto-height {
          height: auto !important;
          overflow: hidden;
          margin-bottom: 20px;
        }

        &.annotations, &.plot {
          overflow-y: auto;
          overflow-x: hidden;
        }

        &.hidden {
          opacity: 0;
        }

        & > div {
          width: 100%;
          height: 100%;
          margin-bottom: -20px;
        }
      }
    }
  }

  @media print {
    .discovery-dashboard-tile {
      break-inside: avoid;
    }
  }
}
